import { useContext, useEffect, useState } from "react";
import { UserContext } from "../Context/UserContext";
import Loader from "./Loader/Loader";
import Modal from "./navbar/RegisterAnd Login/Modal";

const Protected = ({ children }) => {
  const { user, showModal, setShowModal } = useContext(UserContext);
  const [isToken, setIsToken] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const access_token = localStorage.getItem("access_token");
    setIsAdmin(localStorage.getItem("isAdmin"));

    if (!access_token) {
      setIsToken(false);
      setShowModal(true); // Show modal if not logged in
    } else {
      setIsToken(true);
      setShowModal(false);
    }
  }, [user, setShowModal]);

  const handleModalClose = () => {
    setShowModal(false);
  };

  if (!isToken) {
    return <Modal show={showModal} onClose={handleModalClose} />;
  }
  if (!isAdmin) {
    return <Modal show={showModal} onClose={handleModalClose} />;
  }

  if (!user) {
    return <Loader />;
  }

  // If user is authenticated, render children
  return children;
};

export default Protected;